<template>
  <div>
    <v-btn
      class="white--text"
      color="primary"
      @click.prevent="modal_date = true"
      :disabled="disabled"
    >{{$vuetify.lang.t('$vuetify.oeps_report.change_date_time_btn')}}</v-btn>

    <v-dialog
      ref="dialogDate"
      v-model="modal_date"
      :return-value.sync="temp_date"
      persistent
      max-width="400px"
    >
      <v-date-picker v-model="temp_date" scrollable :max="max_date" full-width >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="reset()">{{$vuetify.lang.t('$vuetify.global.cancel')}}</v-btn>
        <v-btn text color="primary" @click="step_two()">{{$vuetify.lang.t('$vuetify.global.ok')}}</v-btn>
      </v-date-picker>
    </v-dialog>



    <v-dialog
        ref="dialogTime"
        v-model="modal_time"
        :return-value.sync="temp_time"
        persistent
        max-width="400px"
      >
        <v-time-picker
          v-if="modal_time"
          v-model="temp_time"
          format="24hr"
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="reset()">{{$vuetify.lang.t('$vuetify.global.cancel')}}</v-btn>
          <v-btn text color="primary" @click="confirmTime()">{{$vuetify.lang.t('$vuetify.global.ok')}}</v-btn>
        </v-time-picker>
      </v-dialog>

  </div>
</template>
<script>
import {DateTimeHelper} from '../../../../helpers/dateTime/DateTimeHelper'
export default {
    props : {
        current_date : {
            type: String,
            required : true
        },
        current_time : {
            type: String,
            required : true
        },
        disabled : {
          type: Boolean
        }
    },
  data: () => {
    return {
      modal_date: false,
      modal_time: false,
      initial_date: "",
      initial_time: "",
      temp_date: "",
      temp_time: "",
      max_date: ""
    }
  },
  methods:{
      step_two(){
          this.$refs.dialogDate.save(this.temp_date);
          this.modal_date = false;
          this.modal_time = true;
      },
      confirmTime(){
          this.$refs.dialogTime.save(this.temp_time);
          this.modal_time = false;
          const time = this.temp_time.split(':');
          time[2] = '00';
          //console.log(time);
          this.$emit('dateTimeConfirmed',
          {
              date : this.temp_date,
              time : time.join(':')
          });
      },
      reset(){
          this.modal_date = false;
          this.modal_time = false;
          this.temp_date = this.initial_date;
          this.temp_time = this.initial_time;
      }
  },
  created(){
      this.max_date = DateTimeHelper.getCurrentDate();
      this.initial_date = this.$props.current_date;
      this.temp_date = this.$props.current_date;
      this.initial_time = this.$props.current_time;
      this.temp_time = this.$props.current_time;
  }
};
</script>